<template>
    <el-dialog
      title="" 
      :visible.sync="dialogVisible"
      top="100px"
      width="460px" 
      :before-close="handleClose">
      <img style="width:400px;heigth:400px;margin:0 0 20px 20px;" :src="'/ticket/ticket_qrcode_' + ticket.orderId"/>
    </el-dialog>
</template>

<script>
export default {
  name: "TicketQRCodeDialog",

  data() {
    return {
        dialogVisible: false,
        ticket : {}
    };
  },

  methods: {
    show( _ticket ) {
        this.ticket = _ticket;
        this.dialogVisible = true;
    },

    //弹出层关闭-指派
    handleClose() {
      this.dialogVisible = false;
    }
  }
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/ticket/TicketQRCodeDialog.vue